<template>
  <div class="fixed-deepseek">
    <!-- 小按钮 @click="isPanel = true" -->
    <div class="deepseek-btn" v-show="!isPanel"></div>
    <!-- 展开页 -->
    <div
      ref="myMessageContainer"
      class="message-container"
      :class="{ 'full-screen': isFullView }"
      v-show="isPanel"
      :style="{
        right: '-91px',
      }"
    >
      <!-- 标题 -->
      <div class="brand-title">
        <div class="ico-box">
          <!--  -->
          <div
            v-click-outside="handleClickOutside"
            style="display: inline-block"
          >
            <t-tooltip theme="light" placement="left">
              <template #content>
                <p class="wx-tooltip-content">
                  {{ $t("DeepSeek.historyRecord") }}
                </p>
              </template>
              <img
                class="ico mg-r"
                :class="{ 'active-history': isHistory }"
                :src="
                  !isHistory
                    ? require('@/assets/DeepSeek/list.svg')
                    : require('@/assets/DeepSeek/list-active.svg')
                "
                @click="isHistory = !isHistory"
                :alt="$t('DeepSeek.historyRecord')"
              />
            </t-tooltip>
            <!-- 历史任务-选中展开列表 -->
            <div class="box-list" v-show="isHistory">
              <ul class="dialogue-list">
                <li
                  class="item"
                  v-show="item.items.length > 0 && listEmptyData === false"
                  v-for="(item, index) in dialogueList"
                  :key="'dialogue' + index"
                >
                  <!-- 时间归类 -->
                  <p class="date-txt">{{ item.time }}</p>
                  <ul class="dialogue-box">
                    <template
                      v-for="(items, index) in item.items"
                      :key="'dialogue' + index"
                    >
                      <li
                        class="item"
                        v-if="items.createTime"
                        :class="{ 'item-active': dialogueActive === items.id }"
                        @click="onDialogue(items, index)"
                      >
                        <p class="name">{{ items.title }}</p>
                        <!-- 编辑 -->
                        <!-- <div class="ico edit-btn"></div> -->
                        <!-- 删除 -->
                        <div
                          class="ico delete-btn"
                          @click.stop="onDeleteSession(items)"
                        ></div>
                      </li>
                    </template>
                  </ul>
                </li>
                <li class="no-data" v-show="listEmptyData === true">
                  <img
                    class="deepseek-ico"
                    src="@/assets/DeepSeek/Vector.svg"
                    alt="DeepSeek"
                  />
                  {{ $t("DeepSeek.noDialogue") }}
                </li>
              </ul>
            </div>
          </div>
          <!--  -->
          <t-tooltip theme="light" placement="top">
            <template #content>
              <p class="wx-tooltip-content">{{ $t("DeepSeek.newDialogue") }}</p>
            </template>
            <img
              class="ico"
              src="@/assets/DeepSeek/Message-ico.svg"
              @click="onNewDialogue"
              :alt="$t('DeepSeek.newDialogue')"
            />
          </t-tooltip>
        </div>
        <span class="title">
          <img src="@/assets/DeepSeek/ai-title.png" />
        </span>
        <div class="ico-box">
          <t-tooltip theme="light" placement="top">
            <template #content>
              <p class="wx-tooltip-content">
                {{
                  !isFullView
                    ? $t("DeepSeek.fullScreen")
                    : $t("DeepSeek.exitFullScreen")
                }}
              </p>
            </template>
            <img
              class="ico"
              @click="onFullView"
              :src="
                !isFullView
                  ? require('@/assets/DeepSeek/fullsreen.svg')
                  : require('@/assets/DeepSeek/fullsreen1.svg')
              "
              :alt="$t('DeepSeek.fullScreen')"
            />
          </t-tooltip>
          <img
            class="ico mg-l"
            @click="isPanel = false"
            src="@/assets/DeepSeek/close.svg"
            alt="关闭"
          />
        </div>
      </div>

      <!-- 聊天内容 -->
      <div class="chat-box" ref="myRefChatBox" @scroll="onChatScroll">
        <div class="chat-scroll" ref="myRefChatScroll">
          <ul
            class="chat-list"
            v-for="(item, index) in historyList"
            :key="index + 'historyList'"
          >
            <!-- 自己的聊天记录 -->
            <li class="item chat-right">
              <t-tooltip theme="light" placement="top">
                <template #content>
                  <p class="wx-tooltip-content">{{ $t("DeepSeek.copy") }}</p>
                </template>
                <div class="ico copy-ico" @click="CopLink(item.problem)"></div>
              </t-tooltip>
              <!-- <t-tooltip theme="light" placement="bottom">
                <template #content>
                  <p class="wx-tooltip-content">编辑消息</p>
                </template>
                <div class="ico edit-ico"></div>
              </t-tooltip> -->
              <p class="txt">{{ item.problem }}</p>
            </li>
            <!-- AI的聊天记录 -->
            <li class="item chat-left">
              <div class="prompt-box">
                <div class="ai-ico"></div>
                <div class="ai-chat-box">
                  <!-- 开启R1的加载中样式 -->
                  <div
                    class="ai-chat-style ai-chat-tips"
                    v-if="
                      item.stopState === false &&
                      isDeepSeekState === true &&
                      isBtnInProgress === true
                    "
                  >
                    <div class="ico AI-ico"></div>
                    <!-- 正在回答问题的时候，显示思考中 -->
                    <p class="txt">{{ $t("DeepSeek.thinking") }}...</p>
                    <!-- isExpand 是否折叠显示回答内容 -->
                    <div
                      class="ico"
                      :class="[item.isExpand ? 'chevron-ico' : 'down-ico']"
                      @click="item.isExpand = !item.isExpand"
                    ></div>
                  </div>
                  <!-- 默认V3的加载中样式 -->
                  <div
                    class="ai-chat-style"
                    v-if="
                      item.stopState === false &&
                      isDeepSeekState === false &&
                      isBtnInProgress === true
                    "
                  >
                    <div class="loading-blue-ico"></div>
                  </div>
                  <!-- 回答的答案 -->
                  <div class="ai-chat-style">
                    <div :class="{ 'txt-box-expand': !item.isExpand }">
                      <!-- 深度思考 -->
                      <p class="txt txt-thought" v-show="item.thoughtProcess">
                        {{ item.thoughtProcess }}
                      </p>
                      <!-- DeepSeek-回答 -->
                      <p class="txt txt-summarize">{{ item.summarize }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 复制-重新生成功能 -->
              <div class="action-bar">
                <t-tooltip
                  v-if="item.stopState !== false && item.summarize !== ''"
                  theme="light"
                  placement="top"
                >
                  <template #content>
                    <p class="wx-tooltip-content">{{ $t("DeepSeek.copy") }}</p>
                  </template>
                  <div
                    class="ico copy-ico"
                    @click="CopLink(item.summarize)"
                  ></div>
                </t-tooltip>
                <t-tooltip
                  v-if="!isBtnInProgress"
                  theme="light"
                  placement="bottom"
                >
                  <template #content>
                    <p class="wx-tooltip-content">
                      {{ $t("DeepSeek.regenerate") }}
                    </p>
                  </template>
                  <div
                    class="ico refresh-ico"
                    @click="onRegenerate(item)"
                  ></div>
                </t-tooltip>
                <!-- <t-tooltip
                  v-if="item.summarize === ''"
                  theme="light"
                  placement="bottom"
                >
                  <template #content>
                    <p class="wx-tooltip-content">继续生成</p>
                  </template>
                  <div
                    class="ico edit-ico"
                    @click="onContinueTxt(item, index)"
                  ></div>
                </t-tooltip> -->
              </div>
              <!-- 消息-翻页 -->
              <!-- <div class="action-bar">
                <div class="ico chevron-left-ico"></div>
                <div class="val">1/2</div>
                <div class="ico chevron-right-ico"></div>
              </div> -->
            </li>
          </ul>
        </div>
      </div>

      <!-- 消息发送区域 -->
      <div class="message-bg">
        <div class="message-box">
          <!-- <t-input
          class="message-input"
          v-model="problem"
          :disabled="isBtnInProgress === false ? false : true"
          @Enter="onSendingMessages"
          placeholder="给 DeepSeek 发送消息"
        /> -->
          <t-textarea
            class="message-input"
            v-model="problem"
            :autosize="{ maxRows: 1 }"
            :disabled="isBtnInProgress === false ? false : true"
            @keydown="onKeydownSendingMessages"
            :placeholder="$t('DeepSeek.sendMessage')"
          />
        </div>
        <div class="message-box">
          <t-tooltip theme="light" placement="left">
            <template #content>
              <p class="wx-tooltip-content" v-if="isDeepSeekState === false">
                {{ $t("DeepSeek.useNewModel") }}
              </p>
            </template>
            <div
              class="ai-state-btn"
              :class="{ 'active-history': isDeepSeekState }"
              @click="isDeepSeekState = !isDeepSeekState"
            >
              <img
                class="ico"
                :src="
                  !isDeepSeekState
                    ? require('@/assets/DeepSeek/AI.svg')
                    : require('@/assets/DeepSeek/AI-active.svg')
                "
                alt="DeepSeek"
              />
              <span class="txt">{{ $t("DeepSeek.deepThinking") }} (R1)</span>
            </div>
          </t-tooltip>

          <p class="message-input"></p>

          <!-- 正常状态 -->
          <div
            class="send-btn-ico"
            v-if="isBtnInProgress === false && problem.trim() !== ''"
            @click="onSendingMessages"
          ></div>
          <!-- 正在处理中 -->
          <t-tooltip
            v-else-if="isBtnInProgress === true"
            theme="light"
            placement="top"
          >
            <template #content>
              <p class="wx-tooltip-content">{{ $t("DeepSeek.endAnswer") }}</p>
            </template>
            <div class="in-progress-ico" @click="onSendStop"></div>
          </t-tooltip>

          <!-- 禁用中 -->
          <div class="send-btn-ico-disable" v-else></div>
        </div>
      </div>

      <div class="dl-box" v-show="delDl">
        <div class="dl-content">
          <p class="title">{{ $t("DeepSeek.deleteDialogueTitle") }}</p>
          <p class="txt">{{ $t("DeepSeek.deleteDialogueConfirm") }}</p>
          <div class="btn-list">
            <div class="btn btn-cancel" @click="delDl = false">
              {{ $t("DeepSeek.cancel") }}
            </div>
            <div class="btn btn-del" @click="onDeekseekDeleteSession">
              {{ $t("DeepSeek.delete") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick } from "vue";
import { MessagePlugin } from "tdesign-vue-next";
import { useI18n } from "vue-i18n";

import {
  deekseekAskProblem,
  deekseekDeleteSession,
  getNewSessionId,
  getProblemList,
  getSessionHistoryList,
} from "@/api/DeepSeek.js";

const { t } = useI18n();

const socketClient = ref(null);

const myRefChatBox = ref(null); // 聊天框ref
const myMessageContainer = ref(null); // 消息容器ref
const myRefChatScroll = ref(null); // 回答列表ref

const sessionId = ref("");
const sessionIds = ref(""); // 保存一份初始化的id

const isPanel = ref(false); // false：收起状态 true：展开状态

const isHistory = ref(false); // 历史记录状态是否选中

const isFullView = ref(false); // 是否全屏

const isDeepSeekState = ref(true); // DeepSeek模式（开启后调用 R1，默认为 V3）

const problem = ref(""); // 要发送的问题

const isBtnInProgress = ref(false); // 发消息按钮，是否正在处理中

const dialogueList = ref([]); // 对话列表
const listEmptyData = ref(false);
const dialogueActive = ref(""); // 选中的对话

const historyList = ref([]); // 问题聊天记录

const delDl = ref(false); // 删除会话弹出框
const dialogueSelectData = ref({});

const getSessionId = async () => {
  const res = await getNewSessionId({
    model: !isDeepSeekState.value ? 1 : 0, // 0（R1）  1(V3)
  });

  if (res.code === 1 && res.data) {
    // 接口返回了 sessionId
    sessionId.value = res.data;
    sessionIds.value = res.data;
    socketInit();
  }
};

/* ---------------------------------------------- */
const sessionStorageData = {
  sessionId: "", // 对话id（初始化的id--新建对话的id）
  dialogueList: [], // 对话列表（点击过暂停的对话项都会存在这里）
  historyList: [], // 问题聊天记录
};
const addSessionData = () => {
  sessionStorage.setItem("historyList", JSON.stringify(historyList.value));
};

const historyLists = ref([]); // 问题聊天记录
/* ---------------------------------------------- */

/* ---------------------------------------------- */
const socketInit = () => {
  if (typeof WebSocket === "undefined") {
    alert("您的浏览器不支持socket");
  } else {
    // 实例化socket
    socketClient.value = new WebSocket(window.g.AI_SOCKET);
    // 监听socket连接
    socketClient.value.addEventListener("open", (event) => {
      scoketOpen(event);
    });
    // 监听socket错误信息
    socketClient.value.addEventListener("error", (event) => {
      console.log("error", event);
    });
    socketClient.value.addEventListener("message", (event) => {
      getMessage(event);
    });
  }
};
const scoketOpen = (e) => {
  // console.log("scoketOpen", e);
  //添加状态判断，当为OPEN时，发送消息
  // console.log(
  //   "scoketOpen,socketClient.value.readyState:",
  //   socketClient.value.readyState
  // );
  const param = { liveid: sessionId.value, type: "101" };
  if (socketClient.value.readyState === 1) {
    socketClient.value.send(JSON.stringify(param));
  }
};
const getMessage = (event) => {
  /*
    data.model: "deepseek-v3" 代表使用的是V3
    data.model: "deepseek-r1" 代表使用的是R1
    data.choices 是个数组
    data.choices[0].delta.content V3模式取（content字段）DeepSeek回答的内容
    data.choices[0].delta.reasoning_content R1模式才有的字段，返回的是DeepSeek的深度思考
    data.choices[0].finish_reason: "stop" 代表回答停止了，否则返回null
    */
  const data = JSON.parse(event.data);
  const choices = data.choices[0];
  const delta = data.choices[0].delta;
  if (historyList.value.length > 0) {
    const historyItem = historyList.value[historyList.value.length - 1]; // 最后一项问答
    // 正在回答中
    if (isBtnInProgress.value) {
      historyItem.stopState = false;
      // 拼接回答的消息
      if (delta.reasoning_content) {
        historyItem.thoughtProcess += delta.reasoning_content;
      }
      if (delta.content) {
        historyItem.summarize += delta.content;
      }
      // 聊天框滚动条回答问题的时候，始终保持在最底部
      chatScrollBottom();
    }
    if (choices.finish_reason === "stop") {
      // 修改发送按钮状态
      isBtnInProgress.value = false;
      // 回答完成后才显示复制按钮
      historyItem.stopState = true;
    }
  }

  console.log("getMessage:", data);
};
const WsDestroying = () => {
  // 主动（关闭）断开 Websocket 连接
  socketClient.value.close();
  socketClient.value = null;
};
/* ---------------------------------------------- */

const getTaskList = async () => {
  // 获取任务列表
  const res = await getSessionHistoryList();
  if (res.code === 1 && res.data) {
    const data = res.data;
    data.forEach((item) => {
      item.time = getDeepSeekTimeLabel(item.createTime);
    });

    let types = ["今天", "昨天", "最近7天", "更早"]; // 假定我们知道的类型集合
    let groupedItems = types.map((time) => ({
      time,
      items: data.filter((item) => item.time === time),
    }));

    dialogueList.value = groupedItems;

    // 判断是否有任务数据
    if (data.length === 0) {
      listEmptyData.value = true;
    } else {
      listEmptyData.value = false;
    }
    console.log(dialogueList.value, "dialogueList.value");
  }
};

const getProblem = async (sessionId) => {
  // 获取问题列表
  const res = await getProblemList({
    sessionId: sessionId,
  });
  if (res.code === 1) {
    const data = res.data;
    // 遍历列表，添加"isExpand"字段，默认展开显示
    for (let i = 0, I = data.length; i < I; i++) {
      const item = data[i];
      item.isExpand = true;
    }
    historyList.value = data;
    isHistory.value = false;
    if (sessionId === sessionIds.value && data.length > 0) {
      // 代表是新对话，将"新对话"改名
      // dialogueList.value[0].items[0].title = data[0].problem;
      // getSessionId();
      getTaskList();
    }
    // 滚动到最底部内容
    nextTick(() => {
      chatScrollBottom();
    });
  }
};

//初始化
getSessionId();
getTaskList();

// 自定义指令
const vClickOutside = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => {
      // 这里可以添加更多的判断逻辑，比如是否在特定元素内等。
      if (!el.contains(event.target)) {
        binding.value(); // 调用绑定的方法处理点击外部事件。
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};
const handleClickOutside = () => {
  // 点击元素其它位置，隐藏显示
  if (delDl.value === true) return;
  isHistory.value = false;
};

let draggedItem = null;
let offsetX = 0;
let offsetY = 0;
let startX;
let startY;
let endX;
let endY;
let isDragging = false; // 标志变量，防止重复绑定事件

let messageItem = null;
let offsetXX = ref(0);
// let offsetYY = 0;
let isMessage = false; // 标志变量，防止重复绑定事件
// 拖拽开始
document.addEventListener("mousedown", (event) => {
  if (event.target.classList.contains("deepseek-btn")) {
    event.preventDefault(); // 阻止默认行为
    draggedItem = event.target;

    offsetX = event.clientX - draggedItem.offsetLeft;
    offsetY = event.clientY - draggedItem.offsetTop;
    startX = event.pageX;
    startY = event.pageY;

    // 禁用文本选中
    document.body.style.userSelect = "none";

    // 绑定 mousemove 和 mouseup 事件到 document
    if (!isDragging) {
      document.addEventListener("mousemove", onMousemove);
      document.addEventListener("mouseup", onMouseup);
      isDragging = true;
    }
  }

  if (event.target.classList.contains("message-container")) {
    event.preventDefault(); // 阻止默认行为
    messageItem = event.target;
    console.log("messageItem", event.clientX - messageItem.offsetLeft);
    offsetXX.value = event.clientX - messageItem.offsetLeft;
    // offsetYY = event.clientY - messageItem.offsetTop;

    // 禁用文本选中
    document.body.style.userSelect = "none";

    // 绑定 mousemove 和 mouseup 事件到 document
    if (!isMessage) {
      document.addEventListener("mousemove", onMousemove);
      document.addEventListener("mouseup", onMouseup);
      isMessage = true;
    }
  }
});
const onMousemove = (event) => {
  if (draggedItem) {
    event.preventDefault(); // 阻止默认行为

    draggedItem.style.left = `${event.clientX - offsetX}px`;
    draggedItem.style.top = `${event.clientY - offsetY}px`;
  }

  if (messageItem) {
    event.preventDefault(); // 阻止默认行为

    messageItem.style.left = `${event.clientX - offsetXX.value}px`;
    // messageItem.style.bottom = `-${event.clientY - offsetYY}px`;
  }
};
const onMouseup = (evt) => {
  if (draggedItem) {
    var e = evt || event;
    endX = e.pageX;
    endY = e.pageY;

    draggedItem = null;

    // 恢复文本选中
    document.body.style.userSelect = "auto";

    // 移除 mousemove 和 mouseup 事件
    document.removeEventListener("mousemove", onMousemove);
    document.removeEventListener("mouseup", onMouseup);
    isDragging = false;

    // 计算拖拽距离
    var d = Math.sqrt(
      (startX - endX) * (startX - endX) + (startY - endY) * (startY - endY)
    );
    if (d === 0 || d < 7) {
      isPanel.value = true; // 点击小按钮，展开DeepSeek面板
    }
  }

  if (messageItem) {
    messageItem = null;

    // 恢复文本选中
    document.body.style.userSelect = "auto";

    // 移除 mousemove 和 mouseup 事件
    document.removeEventListener("mousemove", onMousemove);
    document.removeEventListener("mouseup", onMouseup);
    isMessage = false;
  }
};

const activeInfoDialogueList = () => {
  // 选中第一个对话
  if (dialogueList.value.length > 0 && dialogueList.value[0].items.length > 0) {
    onDialogue(dialogueList.value[0].items[0], 0);
  }
};

let isUserScrolling = false; // 标志位：用户是否正在拖拽滚动条
let scrollTimeout = null; // 用于重置标志位的定时器
const chatScrollBottom = () => {
  // 聊天框滚动条，滚动到最底部
  // 如果用户没有拖拽滚动条，则自动滚动到底部
  if (myRefChatScroll.value && !isUserScrolling) {
    myRefChatBox.value.scrollTop = myRefChatScroll.value.scrollHeight;
  }
};
const onChatScroll = () => {
  isUserScrolling = true; // 用户正在拖拽滚动条

  // 清除之前的定时器
  if (scrollTimeout) {
    clearTimeout(scrollTimeout);
  }

  // 设置定时器，一段时间后重置标志位
  scrollTimeout = setTimeout(() => {
    isUserScrolling = false; // 用户停止拖拽滚动条
  }, 500); // 500ms 内没有触发 scroll 事件，则认为用户停止拖拽
};

const getDeepSeekTimeLabel = (dateTimeStr) => {
  // 解析日期并确保时区统一（按本地时区处理）
  const parseDate = (str) => {
    const [datePart, timePart] = str.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = (timePart || "00:00:00")
      .split(":")
      .map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };

  // 获取当前时间和目标时间（保留毫秒精度）
  const now = new Date();
  const targetDate = parseDate(dateTimeStr);

  // 计算纯日期差值（忽略时间部分）
  const getDateDiff = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    return Math.round((d2 - d1) / 86400000); // 精确到整天数
  };

  const dayDiff = getDateDiff(targetDate, now);

  // DeepSeek 对话时间分段规则
  if (dayDiff === 0) return "今天";
  if (dayDiff === 1) return "昨天";
  if (dayDiff > 1 && dayDiff <= 7) return "最近7天";
  return "更早";
};

const CopLink = (txt) => {
  // 创建一个包含当前页面地址的临时文本输入框
  var tempInput = document.createElement("input");
  tempInput.value = txt;
  // 将临时文本输入框添加到页面中
  document.body.appendChild(tempInput);
  // 选择文本框中的内容
  tempInput.select();
  // 执行复制操作
  document.execCommand("copy");
  // 删除临时文本输入框
  document.body.removeChild(tempInput);

  MessagePlugin.success("复制成功");
};

const onDialogue = (val) => {
  // 点去对话任务，切换对话内容
  if (dialogueActive.value === val.id) return;
  dialogueActive.value = val.id;
  // 初始化发送按钮状态
  isBtnInProgress.value = false;
  // 停止Socket
  WsDestroying();
  sessionId.value = val.id;
  getProblem(val.id); // 获取对应sessionId的对话详情列表
  // 重连对应sessionId的ws
  socketInit();
};

const addDialogueList = () => {
  // 向对话列表添加一条新对话的数据
  if (dialogueList.value.length === 0) return;
  dialogueList.value[0].items.unshift({
    id: sessionIds.value,
    videoId: null,
    title: "新对话",
    sort: null,
    status: null,
    creator: "",
    createTime: "",
    updater: "",
    updateTime: "",
    version: null,
    model: null,
  });
  dialogueActive.value = sessionIds.value; // 选中新对话
};

const setChatInfo = () => {
  historyList.value = [];
  // 初始化发送按钮状态
  isBtnInProgress.value = false;
  // 添加新对话，先重新获取新的sessionId，在添加一条新对话，并且重新连接socket
  WsDestroying();
};
const onNewDialogue = async () => {
  /* 点击"新对话"按钮，向对话列表添加一条新对话的数据
    （如果列表第一条已经是新对话了，就不再次重复添加了）
  */
  if (dialogueList.value.length === 0) return;
  const items = dialogueList.value[0].items; // 今天的全部对话
  if (
    items.length > 0 &&
    items[0].title === "新对话" &&
    items[0].id === sessionIds.value
  ) {
    dialogueActive.value = items[0].id;
    setChatInfo();
    sessionId.value = sessionIds.value;
    socketInit();
    // console.log("选中新对话");
  } else {
    dialogueActive.value = "";
    setChatInfo();
    const res = await getNewSessionId({
      model: !isDeepSeekState.value ? 1 : 0, // 0（R1）  1(V3)
    });

    if (res.code === 1 && res.data) {
      // 接口返回了 sessionId
      sessionId.value = res.data;
      sessionIds.value = res.data;
      addDialogueList();
      socketInit();
    }
    // console.log("添加新对话");
  }
};

const onFullView = () => {
  isFullView.value = !isFullView.value;
  if (isFullView.value === true) {
    // 全屏时
    myMessageContainer.value.style.left = null;
  }
};

const onDeleteSession = (val) => {
  // 打开删除对话弹框
  delDl.value = true;
  dialogueSelectData.value = val;
};
const onDeekseekDeleteSession = async () => {
  // 删除对话任务
  if (!dialogueSelectData.value.id) {
    dialogueList.value[0].items.shift();
    delDl.value = false;
    activeInfoDialogueList();
    return;
  }
  const res = await deekseekDeleteSession({
    sessionId: dialogueSelectData.value.id,
  });
  if (res.code === 1) {
    delDl.value = false;
    MessagePlugin.success("删除成功");
    getSessionId();
    getTaskList();
    dialogueActive.value = "";
    historyList.value = [];
  }
};

const onSendingMessages = async () => {
  // 发送消息
  if (problem.value.trim() === "") return;
  const res = await deekseekAskProblem({
    isThink: !isDeepSeekState.value ? 2 : 1, // isThink (1 思考)  （2 不思考）
    model: !isDeepSeekState.value ? 1 : 0, // 0（R1）  1(V3)
    problem: problem.value,
    sessionId: sessionId.value,
  });
  if (res.code === 1) {
    // 发送按钮状态改为"处理中"
    isBtnInProgress.value = true;
    // 如果未选中任何一个对话，则添加一个新对话
    if (dialogueActive.value === "") {
      addDialogueList();
    }
    // 添加新的聊天内容
    setTimeout(() => {
      getProblem(sessionId.value);
    }, 500);
    // historyList.value.push({
    //   problem: problem.value,
    //   thoughtProcess: "",
    //   summarize: "",
    //   isExpand: true, // 默认展开显示回答的内容
    //   stopState: false, // 是否回答完的状态（复制按钮回答完才显示）
    // });
    problem.value = "";
    // chatScrollBottom();
  }
};
const onKeydownSendingMessages = (value, { e }) => {
  // shift加回车发送消息
  if (e.key === "Enter" && !e.shiftKey) {
    onSendingMessages();
    e.preventDefault();
  }
};

const onRegenerate = (val) => {
  // 点击"重新生成"按钮，调发送接口，重新问一个新的同样的问题
  problem.value = val.problem;
  onSendingMessages();
};

const onContinueTxt = async (val, key) => {
  // 继续生成
  console.log("继续生成", val);
  // 获取问题列表
  const res = await getProblemList({
    sessionId: sessionId.value,
  });
  if (res.code === 1) {
    const data = res.data;
    // 遍历列表，添加"isExpand"字段，默认展开显示
    for (let i = 0, I = data.length; i < I; i++) {
      const item = data[i];
      if (val.id === item.id) {
        historyList.value[key].thoughtProcess = item.thoughtProcess;
        historyList.value[key].summarize = item.summarize;
      }
    }
  }
};

const onSendStop = () => {
  // 停止对话
  isBtnInProgress.value = false;
  // getProblem(sessionId.value);
};
</script>

<style lang="less">
.t-popup {
  .t-popup__content {

    .wx-tooltip-content {
      padding: 6px 6px;
    }
  }
}
</style>

<style lang="less" scoped>
.fixed-deepseek {
  position: fixed;
  right: 110px;
  bottom: 111px;
  z-index: 9999;

  .deepseek-btn {
    cursor: all-scroll;
    width: 71px;
    height: 72px;
    background: url(@/assets/DeepSeek/wen-color.png) no-repeat center center;
    background-size: 100%;
    margin-right: -20px;
    margin-bottom: -20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -50px;
    left: 0;
  }

  .message-container {
    cursor: all-scroll;
    width: 426px;
    height: calc(100vh - 40px);
    border-radius: 36px;
    border: 1px solid var(--, rgba(255, 255, 255, 0.9));
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 4px 5px 0px rgba(0, 37, 108, 0.05),
      0px 20px 20px 0px rgba(0, 35, 101, 0.1);
    backdrop-filter: blur(30px);
    box-sizing: border-box;
    overflow: hidden;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    position: absolute;
    bottom: -90px;
    z-index: 1;

    .brand-title {
      cursor: initial;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ico-box {
        position: relative;

        .ico {
          cursor: pointer;
          font-size: 24px;
          border-radius: 50%;
          padding: 6px;

          &:hover {
            background-color: rgba(0, 21, 83, 0.05);
          }

          &:active {
            background-color: rgba(0, 21, 83, 0.1);
          }
        }

        .mg-l {
          margin-left: 8px;
        }

        .mg-r {
          margin-right: 8px;
        }

        .active-history {
          border: 1px solid #8eabff;
          background-color: #d9e1ff;
          padding: 5px;
        }

        .box-list {
          width: 300px;
          border-radius: 22px;
          border: 1px solid #fff;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 4px 5px 0px rgba(0, 37, 108, 0.05),
            0px 20px 20px 0px rgba(0, 35, 101, 0.1);
          backdrop-filter: blur(30px);
          box-sizing: border-box;
          padding: 10px;
          position: absolute;
          top: 40px;
          left: 0;
          z-index: 1;

          .dialogue-list {
            height: 210px;
            overflow-x: hidden;
            overflow-y: auto;
            scrollbar-width: none;
            margin-bottom: 20px;

            &::-webkit-scrollbar {
              width: 0;
            }

            &:last-child {
              margin-bottom: 0;
            }

            .item {
              color: rgba(0, 0, 0, 0.9);
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 22px;
              margin-bottom: 4px;

              &:last-child {
                margin-bottom: 0;
              }

              .date-txt {
                padding: 0 10px;
                margin-bottom: 8px;
              }

              .dialogue-box {
                .item {
                  border-radius: 12px;
                  padding: 3px 10px;
                  font-weight: 500;
                  display: flex;
                  align-items: center;

                  &:hover {
                    background: rgba(0, 21, 83, 0.05);
                  }

                  &:active {
                    background: rgba(0, 21, 83, 0.1);
                  }

                  .name {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    flex: 1;
                    margin-right: 10px;
                  }

                  .ico {
                    width: 36px;
                    height: 36px;
                    padding: 0;
                  }

                  .edit-btn {
                    background: url(@/assets/DeepSeek/edit.svg) no-repeat center
                      center;
                    background-size: 20px 20px;
                  }

                  .delete-btn {
                    background: url(@/assets/DeepSeek/delete.svg) no-repeat
                      center center;
                    background-size: 20px 20px;
                  }
                }

                .item-active {
                  background: rgba(0, 21, 83, 0.1);

                  &:hover {
                    background: rgba(0, 21, 83, 0.1);
                  }
                }
              }
            }

            .no-data {
              color: #9499a0;
              font-size: 13px;
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .deepseek-ico {
                width: 53px;
                margin-bottom: 10px;
              }
            }
          }
        }
      }

      .title {
        color: #4d6bfe;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
      }
    }

    .chat-box {
      cursor: initial;
      width: 100%;
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #dcdde1;
      }

      .chat-scroll {
        .chat-list {
          /* height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end; */

          .item {
            margin-bottom: 20px;
          }

          .chat-left {
            .prompt-box {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .ai-ico {
                width: 40px;
                height: 40px;
                border: 1px solid #d9e1ff;
                border-radius: 50%;
                background: white url(@/assets/DeepSeek/Vector.svg) no-repeat
                  center center;
                background-size: 28px 21px;
                box-sizing: border-box;
                flex-shrink: 0;
              }

              .ai-chat-box {
                width: calc(100% - 60px);

                .ai-chat-style {
                  padding: 5px;
                  margin: 5px 0 5px 10px;

                  .txt-box-expand {
                    height: 20px;
                    overflow: hidden;
                  }

                  .txt {
                    color: #858a99;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 20px;
                    word-wrap: break-word;
                    white-space: pre-wrap;
                    width: calc(100%);
                  }

                  .txt-label {
                    text-align: center;
                  }

                  .txt-thought {
                    color: rgba(0, 0, 0, 0.6);
                    padding-left: 9px;
                    border-left: 2px solid #dcdde1;
                    box-sizing: border-box;
                    margin-bottom: 10px;
                  }

                  .txt-summarize {
                    color: rgba(0, 0, 0, 0.9);
                  }

                  @keyframes spin {
                    from {
                      transform: rotate(0deg);
                    }
                    to {
                      transform: rotate(360deg);
                    }
                  }

                  .loading-blue-ico {
                    width: 24px;
                    height: 24px;
                    background: url(@/assets/DeepSeek/loading-blue.svg)
                      no-repeat center center;
                    background-size: 100%;
                    animation: spin 2s linear infinite;
                    -webkit-animation: spin 1.5s linear infinite;
                  }
                }

                .ai-chat-tips {
                  border-radius: 8px;
                  background-color: rgba(0, 21, 83, 0.05);
                  padding: 5px;
                  display: inline-flex;
                  gap: 4px;

                  &:hover {
                    background-color: rgba(0, 21, 83, 0.1);
                  }

                  &:active .txt {
                    color: #535d6d;
                  }

                  &:active .AI-ico {
                    background-image: url(@/assets/DeepSeek/AI-active1.svg);
                  }

                  &:active .chevron-ico {
                    background-image: url(@/assets/DeepSeek/chevron-up-active.svg);
                  }

                  .ico {
                    width: 16px;
                    height: 16px;
                    background: no-repeat center center;
                    background-size: 100%;
                    flex-shrink: 0;
                    margin-top: 2px;
                  }
                  .AI-ico {
                    background-image: url(@/assets/DeepSeek/AI.svg);
                  }
                  .chevron-ico {
                    background-image: url(@/assets/DeepSeek/chevron-up.svg);
                  }
                  .down-ico {
                    background-image: url(@/assets/DeepSeek/chevron-down.svg);
                  }
                }
              }
            }

            .action-bar {
              margin-top: 10px;
              padding-left: 50px;
              display: flex;
              align-items: center;

              .ico {
                cursor: pointer;
                width: 36px;
                height: 36px;
                border-radius: 50%;
                background-size: 100%;
                margin-right: 10px;

                &:hover {
                  background-color: rgba(0, 21, 83, 0.05);
                }

                &:active {
                  background-color: rgba(0, 21, 83, 0.1);
                }
              }

              .copy-ico {
                background: url(@/assets/DeepSeek/copy.svg) no-repeat center
                  center;
              }

              .refresh-ico {
                background: url(@/assets/DeepSeek/refresh.svg) no-repeat center
                  center;
              }

              .edit-ico {
                background: url(@/assets/DeepSeek/edit.svg) no-repeat center
                  center;
              }

              .chevron-left-ico {
                background: url(@/assets/DeepSeek/chevron-left.svg) no-repeat
                  center center;
              }

              .chevron-right-ico {
                background: url(@/assets/DeepSeek/chevron-right.svg) no-repeat
                  center center;
              }

              .val {
                color: #858a99;
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                margin-right: 10px;
              }
            }
          }
          .chat-right {
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;

            &:hover .ico {
              visibility: inherit;
            }

            .ico {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              background: rgba(0, 21, 83, 0.05) no-repeat center center;
              background-size: 24px 24px;
              margin-top: 3px;
              margin-right: 5px;
              flex-shrink: 0;
              visibility: hidden;

              &:active {
                background-color: rgba(0, 21, 83, 0.1);
              }
            }

            .copy-ico {
              background-image: url(@/assets/DeepSeek/copy.svg);
            }

            .edit-ico {
              background-image: url(@/assets/DeepSeek/edit.svg);
            }

            .txt {
              color: rgba(0, 0, 0, 0.9);
              font-size: 14px;
              font-weight: 400;
              line-height: 22px;
              word-wrap: break-word;
              white-space: pre-wrap;
              border-radius: 12px;
              background-color: rgba(0, 21, 83, 0.1);
              padding: 10px 20px;
            }
          }
        }
      }
    }

    .message-bg {
      cursor: initial;
      width: 100%;
      border-radius: 16px;
      border: 1px solid #dce0e9;
      background: rgb(243, 244, 246);
      box-shadow: 0px 4px 5px 0px rgba(0, 37, 108, 0.05),
        0px 10px 15px 0px rgba(0, 35, 101, 0.1);
      backdrop-filter: blur(30px);
    }

    .message-box {
      box-sizing: border-box;
      padding: 10px 14px;
      display: flex;
      align-items: center;
      gap: 10px;

      .ico {
        cursor: pointer;
        font-size: 24px;
        border-radius: 50%;
        padding: 6px;
      }

      .message-input {
        flex: 1;
        :deep(.t-input) {
          height: 40px;
          border: none;
          border-radius: 12px;
          background-color: white;
          padding: 10px;
        }

        :deep(.t-textarea__inner) {
          height: 40px;
          border: none;
          border-radius: 12px;
          background-color: white;
          padding: 10px;
        }
      }

      .send-btn-ico {
        cursor: pointer;
        width: 28px;
        height: 28px;
        background: url(@/assets/DeepSeek/send-ico1.svg) no-repeat center center;
        background-size: 100%;

        &:hover {
          background-image: url(@/assets/DeepSeek/send-ico2.svg);
        }

        &:active {
          background-image: url(@/assets/DeepSeek/send-ico3.svg);
        }
      }

      .in-progress-ico {
        cursor: pointer;
        width: 28px;
        height: 28px;
        background: url(@/assets/DeepSeek/In-progress-ico1.svg) no-repeat center
          center;
        background-size: 100%;

        &:hover {
          background-image: url(@/assets/DeepSeek/In-progress-ico2.svg);
        }

        &:active {
          background-image: url(@/assets/DeepSeek/In-progress-ico3.svg);
        }
      }

      .send-btn-ico-disable {
        cursor: no-drop;
        width: 28px;
        height: 28px;
        background: url(@/assets/DeepSeek/send-ico0.svg) no-repeat center center;
        background-size: 100%;
      }

      .ai-state-btn {
        cursor: pointer;
        border-radius: 28px;
        border: 1px solid transparent;
        box-sizing: border-box;
        padding: 4px 7px;
        display: flex;
        align-items: center;

        &:hover {
          background-color: rgba(0, 21, 83, 0.05);
        }

        &:active {
          background-color: rgba(0, 21, 83, 0.1);
        }

        .ico {
          width: 18px;
          height: 18px;
          padding: 0;
        }

        .txt {
          color: rgba(0, 0, 0, 0.4);
          font-size: 12px;
          font-weight: 400;
          margin-left: 4px;
        }
      }

      .active-history {
        border: 1px solid #8eabff;
        background-color: #d9e1ff;

        &:hover {
          background-color: #c3daf8;
        }

        &:active {
          background-color: #d9e1ff;
        }

        .txt {
          color: #4d6bfe;
        }
      }
    }
  }

  .full-screen {
    width: calc(100vw - 40px);

    .chat-box,
    .message-bg {
      max-width: 800px;
    }
  }

  .dl-box {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;

    .dl-content {
      border-radius: 18px;
      border: 1px solid #fff;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 4px 5px 0px rgba(0, 37, 108, 0.05),
        0px 20px 20px 0px rgba(0, 35, 101, 0.1);
      backdrop-filter: blur(30px);
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;

      .title {
        color: rgba(0, 0, 0, 0.9);
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
      }

      .txt {
        color: rgba(0, 0, 0, 0.9);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
      }

      .btn-list {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .btn {
          cursor: pointer;
          line-height: 22px;
          border-radius: 8px;
          padding: 10px 16px;
        }
        .btn-cancel {
          color: #6f7686;
          background-color: rgba(0, 21, 83, 0.1);
        }
        .btn-del {
          color: rgba(255, 255, 255, 0.9);
          background-color: #d54941;
        }
      }
    }
  }
}
</style>
